import { render, staticRenderFns } from "./TransferOwnershipModal.vue?vue&type=template&id=46fe5701&scoped=true&"
import script from "./TransferOwnershipModal.vue?vue&type=script&lang=ts&"
export * from "./TransferOwnershipModal.vue?vue&type=script&lang=ts&"
import style0 from "./TransferOwnershipModal.vue?vue&type=style&index=0&id=46fe5701&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46fe5701",
  null
  
)

export default component.exports